import { JitsiMeeting } from "@jitsi/web-sdk";
import { useSelector } from "react-redux";
const JistiHandler = () => {
    const StudentInfo = useSelector(store => store.AuthReducer.studentData)
    const TestReducer = useSelector(store => store.TestReducer);

    const muteAll = (api) => {
        const participantArray = api.getParticipantsInfo()
        console.log("------------------------------- Participants--------------------------------")
        console.log(participantArray)
        for (let i = 0; i < participantArray.length; i++) {
            const items = participantArray[i];
            api.executeCommand('setParticipantVolume',
                items.participantId, 0
            )
        }
        console.log("------------------------------- Participants--------------------------------")
    }

    return (
        <div style={{display:"none"}}>
            <JitsiMeeting
                domain="meet.jit.si"
                roomName={TestReducer.batch}
                configOverwrite={{
                    startWithAudioMuted: false,
                    startWithVideoMuted: false,
                    prejoinPageEnabled: false,
                    disableDeepLinking: true,
                    disabledSounds: [
                        "ASKED_TO_UNMUTE_SOUND",
                        "E2EE_OFF_SOUND",
                        "E2EE_ON_SOUND",
                        "INCOMING_MSG_SOUND",
                        "KNOCKING_PARTICIPANT_SOUND",
                        "LIVE_STREAMING_OFF_SOUND",
                        "LIVE_STREAMING_ON_SOUND",
                        "NO_AUDIO_SIGNAL_SOUND",
                        "NOISY_AUDIO_INPUT_SOUND",
                        "OUTGOING_CALL_EXPIRED_SOUND",
                        "OUTGOING_CALL_REJECTED_SOUND",
                        "OUTGOING_CALL_RINGING_SOUND",
                        "OUTGOING_CALL_START_SOUND",
                        "PARTICIPANT_JOINED_SOUND",
                        "PARTICIPANT_LEFT_SOUND",
                        "RAISE_HAND_SOUND",
                        "REACTION_SOUND",
                        "RECORDING_OFF_SOUND",
                        "RECORDING_ON_SOUND",
                        "TALK_WHILE_MUTED_SOUND"
                    ],
                    toolbarButtons: []
                }}
                interfaceConfigOverwrite={{
                    DISABLE_JOIN_LEAVE_NOTIFICATIONS: true
                }}
                userInfo={{
                    displayName: `${StudentInfo.name}-${StudentInfo.uid}`
                }}
                onApiReady={(externalApi) => {
                    // var temp = {...externalApi};
                    console.log("---------------------- external api ----------------------")

                    externalApi.addListener("videoConferenceJoined", (data) => {
                        externalApi.pinParticipant(data.id)
                        externalApi.addListener("participantJoined", (student) => {
                            externalApi.executeCommand('setParticipantVolume',
                                student.id, 0
                            )
                            console.log("Someone Joined "+student)
                        })

                        muteAll(externalApi)
                    })

                    console.log(externalApi)
                    console.log("---------------------- external api ----------------------")
                    // here you can attach custom event listeners to the Jitsi Meet External API
                    // you can also store it locally to execute commands
                }}

            />
        </div>
    )
}


export default JistiHandler;